import * as Yup from "yup";

export default Yup.object({
  title: Yup.string().required("Course title is required"),
  description: Yup.string().required("Course description is required"),
  cover: Yup.mixed().required("Course cover is required"),
});
